import { HTMLAttributes, forwardRef } from 'react'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: 'none' | 'sm' | 'md' | 'lg'
  variant?: 'default' | 'parchment' | 'interactive'
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ padding = 'md', variant = 'default', className = '', children, ...props }, ref) => {
    const paddings = {
      none: '',
      sm: 'p-3',
      md: 'p-4',
      lg: 'p-6',
    }

    const variants = {
      default: 'bg-white rounded-card shadow-card border border-cream-100',
      parchment: 'bg-cream-100 rounded-card shadow-card border border-cream-200',
      interactive: 'bg-white rounded-card shadow-card border border-cream-100 transition-all duration-200 hover:shadow-card-hover hover:-translate-y-1 cursor-pointer',
    }

    return (
      <div
        ref={ref}
        className={`overflow-hidden ${variants[variant]} ${paddings[padding]} ${className}`}
        {...props}
      >
        {children}
      </div>
    )
  }
)

Card.displayName = 'Card'
